import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import { ProductImage } from '../ProductImage'
import moment from 'moment'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'
import '@loyal_template/cart.css'
import '@loyal_template/confirmation.css'
import MediaQuery from 'react-responsive'
import { Link } from 'react-router-dom'

const ProductOrderItem = props => {
  let sellingPrice = props.paymentType !== 5 && props.vendorType !== 'Compra de Pontos' ? (<CatalogCurrencyLabel value={props.sellingPrice} />) : (` R$ ${addZeroes(props.cash)}`)
  let vendorName = (props.vendorName &&
  props.vendorName !== 'Compra de Pontos' &&
  props.vendorType !== 'Milhas' && (
    <div className='d-none d-md-block col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
      Fornecido e entregue por: <strong>{props.vendorName}</strong>
    </div>
  )) || (
    ''
  )
  return (
    <div className='cart-item row align-items-center h-100 px-2 border-color-ui-3 border-bottom py-2'>
      <div className='cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'>
        <ProductImage
          imageUrl={props.imageUrl}
          vendorId={props.vendorId}
          vendorType={props.vendorType}
          ready
          ariaHidden
        />
      </div>

      <div className='cart-product-info col'>
        <div className='cart-product-info row align-items-center h-100'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='order-number col-12 mx-0 mb-1 d-none d-md-block'>
                <p className='txt-font-body txt-body'>
                  Pedido: #{props.orderParentId}
                </p>
              </div>
              <div className='product-infos col-12 mx-0'>
                <h2 className='txt-body-sm txt-font-body color-ui-2 '>
                  {props.productName}
                </h2>
              </div>
            </div>
            <div className='row card-price-item mt-1'>
              <MediaQuery minDeviceWidth={426}>
                <div className='d-none d-md-block col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                  Valor: {sellingPrice}
                  {props.paymentType !== 5 &&
                props.vendorType !== 'Compra de Pontos' &&
                props.cash !== 0 &&
                props.paymentType === 2
                    ? ` + R$ ${addZeroes(props.cash)}`
                    : ''}
                  {props.vendorType === 'Compra de Pontos' ? (
                    <span className='d-block'>
                      Quantidade:{' '}
                      <CatalogCurrencyLabel
                        value={props.quanttity * (props.packageSize || 1000)}
                      />
                    </span>
                  ) : (
                    props.vendorType !== 'Milhas' && (
                      <span className='d-block'>
                        Quantidade: <strong>{`${props.quanttity} unidades`}</strong>
                      </span>
                    )
                  )}
                </div>
              </MediaQuery>
              <MediaQuery maxDeviceWidth={425}>
                <div className='d-block d-md-none col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                  {props.vendorType === 'Compra de Pontos' ? (
                    <span className='d-block'>
                      Quantidade:
                      <CatalogCurrencyLabel
                        value={props.quanttity * (props.packageSize || 1000)}
                      />
                    </span>
                  ) : (
                    props.vendorType !== 'Milhas' && (
                      <span className='d-block'>
                        Quantidade: <strong>{`${props.quanttity} unidades`}</strong>
                      </span>
                    )
                  )}
                </div>
                <div className='d-block d-md-none col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                  Valor: {sellingPrice}
                  {props.paymentType !== 5 &&
                props.vendorType !== 'Compra de Pontos' &&
                props.cash !== 0 &&
                props.paymentType === 2
                    ? <strong>{` + R$ ${addZeroes(props.cash)}`}</strong>
                    : ''}
                </div>
              </MediaQuery>
              {props.deliveryDate && props.vendorName !== 'Compra de Pontos' ? (
                <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                  Previsão de entrega:  <strong>{props.deliveryDate
                    ? moment.utc(props.deliveryDate).format('DD/MM/YYYY')
                    : '-'}</strong>
                </div>
              ) : (
                ''
              )}
              {vendorName}
            </div>
          </div>
          <div className='col d-none d-md-block'>
            <Link
              className='btn btn-sm btn-featured btn-cart txt-center'
              to={`/order/${props.parentOrderId}/${props.orderId}/product/${props.productId}?previousRoute=/my-orders?days=365`}
            >
              Ver detalhes
            </Link>
          </div>
        </div>
      </div>
      <div className='col-12 d-block d-md-none mt-1'>
        <Button
          className='btn btn-sm btn-featured btn-cart'
          text='Ver detalhes'
          onClick={() => {
            props.redirect(
              `/order/${props.parentOrderId}/${props.orderId}/product/${props.productId}`
            )
          }}
        />
      </div>
    </div>
  )
}

function addZeroes (value) {
  // set everything to at least two decimals; removs 3+ zero decimasl, keep non-zero decimals
  let newValue = value * 1 // removes trailing zeros
  newValue = newValue + '' // casts it to string

  let pos = newValue.indexOf('.')
  if (pos === -1) newValue = newValue + '.00'
  else {
    var integer = newValue.substring(0, pos)
    var decimals = newValue.substring(pos + 1)
    while (decimals.length < 2) decimals = decimals + '0'
    newValue = integer + ',' + decimals
  }
  return newValue.toString().replace('.', ',')
}

ProductOrderItem.propTypes = {
  productName: PropTypes.string,
  orderParentId: PropTypes.number,
  sellingPrice: PropTypes.number,
  quanttity: PropTypes.number,
  deliveryDate: PropTypes.objectOf(typeof date),
  vendorName: PropTypes.string,
  orderId: PropTypes.number,
  parentOrderId: PropTypes.number,
  productId: PropTypes.number,
  imageUrl: PropTypes.string,
  vendorType: PropTypes.vendorType,
  vendorId: PropTypes.number,
  redirect: PropTypes.func,
  paymentType: PropTypes.number,
  cash: PropTypes.number,
  packageSize: PropTypes.number
}

export default ProductOrderItem



// WEBPACK FOOTER //
// ./src/features/Confirmation/ProductOrderItem.js